export * from '../../shared/config/texts';

export const rootSettings = {
  perPage: 50,
};

export enum DateFormats {
  Date = 'L', // 16.11.1996
  DateTime = 'L HH:mm', // 16.11.1996 12:30
  DateTimeSeconds = 'L HH:mm:ss', // 16.11.1996 12:30:30
  FullTextDate = 'LL', // 16 ноября 1996 г.
  Iso = 'YYYY-MM-DD',
  Time = 'HH:mm', // 12:00
  TimeSeconds = 'HH:mm:ss', // 12:30:30
}

export const monthList = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

export const allTasksLink: {
  filter?: string;
  path: string;
  header: string;
  id: 'allTaskCounter' | 'newTaskCounter' | 'viewedTaskCounter';
}[] = [
  {
    filter: undefined,
    path: '',
    header: 'Все задачи',
    id: 'allTaskCounter',
  },
  {
    filter: 'new',
    path: '/new',
    header: 'Новые',
    id: 'newTaskCounter',
  },
  {
    filter: 'viewed',
    path: '/viewed',
    header: 'Просмотренные',
    id: 'viewedTaskCounter',
  },
];
